import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'loggedout',
  standalone: true,
  imports: [],
  templateUrl: './loggedout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./loggedout.component.scss'],
})
export class LoggedoutComponent {}
